import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';
import type { ConversationAction } from '@atlassian/rovo-conversation-actions/types';

import { LegacyAIProactiveNudge } from './LegacyAIProactiveNudge';

const LazyAIProactiveNudges = React.lazy(() =>
	import(
		/* webpackChunkName: "@atlaskit-internal_ai-proactive-nudges" */ './AIProactiveNudges'
	).then((module) => ({
		default: module.AIProactiveNudges,
	})),
);

type AIProactiveNudgeProps = {
	isPriorityNudgeVisible?: boolean;
	onActiveNudgeChange?: (hasActiveNudge: boolean) => void;
	onPriorityNudgeChange?: (hasPriorityNudge: boolean) => void;
	priorityNudges?: readonly ConversationAction[];
	renderPriorityNudge?: (nudge: ConversationAction, content: React.ReactNode) => React.ReactNode;
};

/**
 * Selects the proactive-nudge presentation controlled by
 * `confluence_rovo_agent_session_nudges`:
 * - disabled: the legacy pinned single-nudge flow;
 * - enabled: up to three independently-lived cards with immediate refill.
 */
export const AIProactiveNudge = ({
	onActiveNudgeChange,
	priorityNudges,
	isPriorityNudgeVisible,
	onPriorityNudgeChange,
	renderPriorityNudge,
}: AIProactiveNudgeProps): JSX.Element => {
	if (fg('confluence_rovo_agent_session_nudges')) {
		return (
			<React.Suspense fallback={null}>
				<LazyAIProactiveNudges
					onActiveNudgeChange={onActiveNudgeChange}
					priorityNudges={priorityNudges}
					isPriorityNudgeVisible={isPriorityNudgeVisible}
					onPriorityNudgeChange={onPriorityNudgeChange}
					renderPriorityNudge={renderPriorityNudge}
				/>
			</React.Suspense>
		);
	}

	return (
		<LegacyAIProactiveNudge
			onActiveNudgeChange={onActiveNudgeChange}
			priorityNudges={priorityNudges}
			isPriorityNudgeVisible={isPriorityNudgeVisible}
			onPriorityNudgeChange={onPriorityNudgeChange}
			renderPriorityNudge={renderPriorityNudge}
		/>
	);
};
